module.exports = __webpack_public_path__ + "img/complate.aac4841b.svg";